import { Box, Typography, useTheme } from '@mui/joy';
import { SxProps } from '@mui/joy/styles/types';
import { Trans } from 'react-i18next';

import { Price, Warning } from 'core/elements';
import { getPercentage } from 'core/utils';
import { Color, Level } from 'theme/enums';

interface IProps {
  label?: string;
  value?: number;
  options?: {
    classNames?: string;
    isPercentage?: boolean;
    wrapperSx?: SxProps;
    valueProps?: { color?: Color; level?: Level; onClick?: () => void };
    warning?: string;
  };
}

const Percentange = ({
  value,
  color = Color.NEUTRAL,
  level = null,
}: {
  value: number | string;
  color?: Color;
  level?: Level;
}) => {
  return (
    <Typography color={color} sx={{ fontSize: 'inherit' }} level={level}>
      {getPercentage(value)}
    </Typography>
  );
};

const TotalPrice = ({ label, value, options = {} }: IProps) => {
  const theme = useTheme();

  const {
    classNames = '',
    isPercentage = false,
    wrapperSx = {},
    valueProps = {},
    warning = '',
  } = options;

  const totalContent = (
    <Trans
      i18nKey={'titleTotalPrice'}
      values={{ label }}
      components={{
        priceWrapper: <Box sx={{ color: theme.palette.neutral[800], fontWeight: 700 }} />,
        price: isPercentage ? (
          <Percentange value={value} color={warning ? Color.DANGER : null} {...valueProps} />
        ) : (
          <Price
            amount={value}
            level={Level.BODY_MD}
            labelColor={Color.NEUTRAL}
            color={warning ? Color.DANGER : null}
            {...valueProps}
          />
        ),
      }}
    />
  );

  return (
    <Box className={classNames}>
      <Box
        sx={{
          display: 'flex',
          gap: '4px',
          color: theme.palette.neutral[600],
          fontWeight: 500,
          ...wrapperSx,
        }}
      >
        {warning && <Warning tooltipTitle={warning} content={totalContent} />}

        {!warning && totalContent}
      </Box>
    </Box>
  );
};

export default TotalPrice;
